(function(w,d){
  'use strict';
  if (w.__ES_PDP_FORM_BOOT__) return;
  w.__ES_PDP_FORM_BOOT__ = true;

  function onJqReady(fn){
    if (typeof w.ES_jqReady === 'function') {
      w.ES_jqReady(fn);
      return;
    }
    function run(){ if (w.jQuery) fn(w.jQuery); }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run, { once:true });
    else run();
  }

  onJqReady(function($){
    var productData = w.__ES_PDP_PRODUCT_DATA || null;
    if (!productData) return;

    var $pdpForm = $('#AddToCartForm').first();
    if (!$pdpForm.length) return;
    var $pdpRoot = $pdpForm.closest('.content-page-detail');
    if (!$pdpRoot.length) $pdpRoot = $('body.template-product').first();

    w.ES_PDP_COLOR_OPTION_INDEX = (typeof w.__ES_PDP_COLOR_OPTION_INDEX === 'number') ? w.__ES_PDP_COLOR_OPTION_INDEX : 0;
    w.ES_PDP_VARIANTS = productData.variants || [];
    w.ES_PDP_IMAGES = w.__ES_PDP_IMAGE_DATA || [];

    function resizeShopifyImageUrl(src, width){
      if (!src) return '';
      var value = String(src);
      try {
        var url = new URL(value, d.baseURI);
        if (/cdn\.shopify\.com|shopifycdn\.net/i.test(url.hostname)) {
          url.searchParams.set('width', String(width || 1600));
          return url.href;
        }
      } catch(e) {}
      return value
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.[a-z0-9]+(?:\?|$))/i, '')
        .replace(/_(\d+)(x\d+)?x?(?=\.[a-z0-9]+(?:\?|$))/i, '')
        .replace(/(\.[a-z0-9]+)(?:\?.*)?$/i, '_'+ String(width || 1600) +'x$1');
    }

    function syncPdpMainLink(src){
      if (!src) return;
      var href = resizeShopifyImageUrl(src, 2400);
      $pdpRoot.find('[data-es-pdp-main-link]').first().attr('href', href);
    }

    function normalizePdpImageIdentity(src){
      if (!src) return '';
      var value = String(src).trim();
      if (!value) return '';
      try {
        var url = new URL(value, d.baseURI);
        if (/cdn\.shopify\.com|shopifycdn\.net/i.test(url.hostname)) {
          ['width', 'height', 'crop', 'pad_color'].forEach(function(key){ url.searchParams.delete(key); });
          var pathname = url.pathname
            .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.[a-z0-9]+$)/i, '')
            .replace(/_(\d+)(x\d+)?x?(?=\.[a-z0-9]+$)/i, '');
          return (url.hostname + pathname).toLowerCase();
        }
      } catch(e) {}
      return value
        .split('?')[0]
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.[a-z0-9]+$)/i, '')
        .replace(/_(\d+)(x\d+)?x?(?=\.[a-z0-9]+$)/i, '')
        .toLowerCase();
    }

    function isSamePdpMainMedia($img, source, mediaId){
      try {
        if (!$img || !$img.length) return false;
        var currentId = String($img.attr('data-es-media-id') || '').trim();
        var wantedId = String(mediaId || '').trim();
        if (currentId && wantedId && currentId === wantedId) return true;
        var el = $img.get(0);
        var currentSrc = String($img.attr('src') || (el && el.currentSrc) || '').trim();
        return !!currentSrc && normalizePdpImageIdentity(currentSrc) === normalizePdpImageIdentity(source);
      } catch(e) { return false; }
    }

    function preloadPdpImageAsset(src, onLoad, onError){
      if (!src) {
        if (typeof onError === 'function') onError();
        return;
      }
      var done = false;
      var pre = new Image();
      pre.decoding = 'async';
      pre.onload = function(){
        if (done) return;
        done = true;
        if (typeof onLoad === 'function') onLoad(pre);
      };
      pre.onerror = function(){
        if (done) return;
        done = true;
        if (typeof onError === 'function') onError();
      };
      pre.src = src;
      try { if (pre.complete && pre.naturalWidth) pre.onload(); } catch(e) {}
    }

    function swapPdpMainImageWhenReady($img, src, onAfter){
      try {
        if (!$img || !$img.length || !src) {
          if (typeof onAfter === 'function') onAfter();
          return;
        }
        var el = $img.get(0);
        if (!el) {
          if (typeof onAfter === 'function') onAfter();
          return;
        }
        var current = String($img.attr('src') || '').trim();
        if (current === src) {
          if (typeof onAfter === 'function') onAfter();
          return;
        }
        var token = (el.__esPdpSwapToken || 0) + 1;
        el.__esPdpSwapToken = token;
        var finalize = function(){
          if (!el || el.__esPdpSwapToken !== token) return;
          try { $img.addClass('es-image-fading'); } catch(_e0) {}
          $img.removeAttr('srcset sizes data-srcset data-sizes').attr('src', src).attr('data-src', src);
          syncPdpMainLink(src);
          var raf = w.requestAnimationFrame || function(fn){ return w.setTimeout(fn, 16); };
          raf(function(){
            raf(function(){
              if (!el || el.__esPdpSwapToken !== token) return;
              try { $img.removeClass('es-image-fading'); } catch(_e1) {}
              if (typeof onAfter === 'function') {
                w.setTimeout(function(){
                  if (!el || el.__esPdpSwapToken !== token) return;
                  try { onAfter(); } catch(_e2) {}
                }, 20);
              }
            });
          });
        };
        preloadPdpImageAsset(src, finalize, finalize);
      } catch(e) {
        if (typeof onAfter === 'function') { try { onAfter(); } catch(_e3) {} }
      }
    }


    function applyPdpSoldOutCtaVisual(target, forceState){
      try {
        var $buttons = target && target.jquery ? target : $(target || $pdpForm.find('[data-es-primary-cta], .shop-button-soldout'));
        $buttons.each(function(){
          var el = this;
          if (!el) return;
          var $el = $(el);
          var text = $.trim($el.text() || $el.val() || '').toLowerCase();
          var isOos = (typeof forceState === 'boolean') ? forceState : (
            el.disabled ||
            $el.hasClass('disabled') ||
            $el.hasClass('shop-button-soldout') ||
            /out\s+of\s+stock|sold\s+out|unavailable/.test(text)
          );
          $el.toggleClass('es-pdp-oos-visual', isOos);
          if (isOos) el.setAttribute('aria-disabled', 'true');
          else if (!el.disabled) el.removeAttribute('aria-disabled');
        });
      } catch(e) {}
    }

    function initLinkedOptions(){
      if (!productData.options || productData.options.length <= 1) return;
      var ShopifyNS = w.Shopify = w.Shopify || {};
      var uniq = typeof ShopifyNS.uniq === 'function' ? ShopifyNS.uniq : function(values){
        return values.filter(function(value, index, list){ return list.indexOf(value) === index; });
      };
      var linkedObserver = null;
      var linkedPagehideHandler = null;
      var linkedPageshowHandler = null;
      var optionsMap = {};

      function disconnectObserver(){
        if (linkedObserver && typeof linkedObserver.disconnect === 'function') {
          try { linkedObserver.disconnect(); } catch(e) {}
        }
        linkedObserver = null;
      }

      function buildMap(){
        optionsMap = {};
        (productData.variants || []).forEach(function(variant){
          if (!variant) return;
          optionsMap.root = optionsMap.root || [];
          optionsMap.root.push(variant.option1);
          optionsMap.root = uniq(optionsMap.root);
          if ((productData.options || []).length > 1) {
            var key = variant.option1;
            optionsMap[key] = optionsMap[key] || [];
            optionsMap[key].push(variant.option2);
            optionsMap[key] = uniq(optionsMap[key]);
          }
          if ((productData.options || []).length === 3) {
            var key3 = variant.option1 + ' / ' + variant.option2;
            optionsMap[key3] = optionsMap[key3] || [];
            optionsMap[key3].push(variant.option3);
            optionsMap[key3] = uniq(optionsMap[key3]);
          }
        });
      }

      function updateSelector(selectorIndex){
        var key, $selector;
        if (selectorIndex === 0) {
          key = 'root';
          $selector = $pdpForm.find('.single-option-selector').eq(0);
        } else if (selectorIndex === 1) {
          key = $pdpForm.find('.single-option-selector').eq(0).val();
          $selector = $pdpForm.find('.single-option-selector').eq(1);
        } else {
          key = $pdpForm.find('.single-option-selector').eq(0).val() + ' / ' + $pdpForm.find('.single-option-selector').eq(1).val();
          $selector = $pdpForm.find('.single-option-selector').eq(2);
        }
        if (!$selector.length) return;
        var initialValue = $selector.val();
        var availableOptions = optionsMap[key] || [];
        $selector.empty();
        availableOptions.forEach(function(option){
          $selector.append($('<option></option>').val(option).html(option));
        });
        $pdpForm.find('.swatch[data-option-index="' + selectorIndex + '"] > .es-swatch-strip > [data-value], .swatch[data-option-index="' + selectorIndex + '"] > [data-value]').each(function(){
          var $item = $(this);
          var radio = $item.find(':radio');
          if ($.inArray($item.attr('data-value'), availableOptions) !== -1) {
            var esOriginalSoldout = String($item.attr('data-es-soldout') || '') === '1';
            $item.toggleClass('soldout', esOriginalSoldout).show();
            radio.prop('disabled', false).removeAttr('aria-disabled');
          } else {
            $item.addClass('soldout').hide();
            radio.prop('checked', false).prop('disabled', true).attr('aria-disabled', 'true');
          }
        });
        if ($.inArray(initialValue, availableOptions) !== -1) $selector.val(initialValue);
        $selector.trigger('change');
      }

      function bindChangeHandlers(){
        var $sel0 = $pdpForm.find('.single-option-selector').eq(0);
        var $sel1 = $pdpForm.find('.single-option-selector').eq(1);
        $sel0.off('change.esLinkedOptions').on('change.esLinkedOptions', function(){
          updateSelector(1);
          if ((productData.options || []).length === 3) updateSelector(2);
          return true;
        });
        $sel1.off('change.esLinkedOptions').on('change.esLinkedOptions', function(){
          if ((productData.options || []).length === 3) updateSelector(2);
          return true;
        });
      }

      function runLinking(){
        var $selectors = $pdpForm.find('.single-option-selector');
        if (!$selectors.length) return false;
        buildMap();
        updateSelector(0);
        if ((productData.options || []).length > 1) updateSelector(1);
        if ((productData.options || []).length === 3) updateSelector(2);
        bindChangeHandlers();
        disconnectObserver();
        return true;
      }

      function cleanupLinked(){
        disconnectObserver();
        $pdpForm.find('.single-option-selector').eq(0).off('change.esLinkedOptions');
        $pdpForm.find('.single-option-selector').eq(1).off('change.esLinkedOptions');
        if (linkedPagehideHandler) {
          try { w.removeEventListener('pagehide', linkedPagehideHandler); } catch(e) {}
        }
        if (linkedPageshowHandler) {
          try { w.removeEventListener('pageshow', linkedPageshowHandler); } catch(e) {}
        }
      }

      if (w.__esLinkedOptionsCleanup) {
        try { w.__esLinkedOptionsCleanup(); } catch(e) {}
      }
      w.__esLinkedOptionsCleanup = cleanupLinked;

      if (!runLinking()) {
        var addToCartForm = $pdpForm.get(0);
        if (w.MutationObserver && addToCartForm) {
          linkedObserver = new MutationObserver(function(mutations){
            for (var i = 0; i < mutations.length; i++) {
              var m = mutations[i];
              if (m.target && m.target.nodeType === 1 && ((m.target.matches && m.target.matches('.single-option-selector')) || (m.target.querySelector && m.target.querySelector('.single-option-selector')))) {
                if (runLinking()) return;
              }
              if (!m.addedNodes || !m.addedNodes.length) continue;
              for (var j = 0; j < m.addedNodes.length; j++) {
                var node = m.addedNodes[j];
                if (!node || node.nodeType !== 1) continue;
                if ((node.matches && node.matches('.single-option-selector')) || (node.querySelector && node.querySelector('.single-option-selector'))) {
                  if (runLinking()) return;
                }
              }
            }
          });
          linkedObserver.observe(addToCartForm, { childList:true, subtree:true });
        }
      }

      linkedPagehideHandler = function(){
        disconnectObserver();
      };
      linkedPageshowHandler = function(){
        if (!$pdpForm.find('.single-option-selector').length) return;
        try { runLinking(); } catch(e) {}
      };
      w.addEventListener('pagehide', linkedPagehideHandler);
      w.addEventListener('pageshow', linkedPageshowHandler);
    }

    w.ES_PDP_HoverSwap = w.ES_PDP_HoverSwap || (function(){
      var $overlay = null;
      var $wrapEl = null;
      var initialized = false;
      var HOVER_DELAY_MS = 160;
      var DESKTOP_MIN_WIDTH = 992;
      var hoverTimer = null;
      var lastAlt = '';

      function normalize(url){
        if(!url) return '';
        var clean = String(url).replace(/^https?:/,'').split('?')[0];
        clean = clean
          .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.)/i,'')
          .replace(/_(\d+)(x\d+)?x?(?=\.)/i,'');
        return clean;
      }

      function shouldEnable(){
        try{
          if(w.innerWidth < DESKTOP_MIN_WIDTH) return false;
          if(w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches) return true;
          return false;
        }catch(e){
          return w.innerWidth >= DESKTOP_MIN_WIDTH;
        }
      }

      function findWrap(){
        var $w = $pdpRoot.find('.js_prod_main').first();
        if($w.length) return $w;
        var $main = $pdpRoot.find('.main_img .engoj_img_main').first();
        if(!$main.length) $main = $pdpRoot.find('[data-es-pdp-main-image], .engoj_img_main').first();
        if(!$main.length) return $();
        $w = $main.closest('.img_thumb, .product-single__photo, .product-media, .product-gallery, .product-images');
        if($w.length) return $w;
        return $main.parent();
      }

      function ensureOverlay(){
        if(initialized) return;
        if(!shouldEnable()) return;
        var $wrap = findWrap();
        if(!$wrap.length) return;
        $wrapEl = $wrap;
        $wrapEl.addClass('es-pdp-hover-swap');
        if(!$wrapEl.find('.es-pdp-hover-alt').length){
          $overlay = $('<img class="es-pdp-hover-alt" alt="" aria-hidden="true" loading="lazy" draggable="false" />');
          $wrapEl.append($overlay);
        } else {
          $overlay = $wrapEl.find('.es-pdp-hover-alt').first();
        }
        bindHover();
        bindGalleryEvents();
        initialized = true;
      }

      function bindHover(){
        if(!$wrapEl || !$wrapEl.length) return;
        if($wrapEl.data('esHoverSwapBound')) return;
        $wrapEl.data('esHoverSwapBound', '1');
        $wrapEl.on('mouseenter', function(){
          if(!shouldEnable()) return;
          if(!$overlay || !$overlay.length) return;
          if(!$overlay.attr('src')) return;
          var img = $overlay.get(0);
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function(){
            if(!$wrapEl || !$wrapEl.length) return;
            if(!shouldEnable()) return;
            if(!$wrapEl.is(':hover')) return;
            if(!img || !img.complete || img.naturalWidth === 0) return;
            $wrapEl.addClass('es-pdp-hovering');
          }, HOVER_DELAY_MS);
        });
        $wrapEl.on('mouseleave', function(){
          clearTimeout(hoverTimer);
          hoverTimer = null;
          $wrapEl.removeClass('es-pdp-hovering');
        });
      }

      function bindGalleryEvents(){
        if(w.__esPdpHoverSwapGalleryBound) return;
        var tries = 0;
        (function waitForGallery(){
          tries++;
          var $g = $pdpRoot.find('.js_prod_main').first();
          if($g.length && $g.hasClass('slick-initialized')){
            $g.off('afterChange.esPdpHoverSwap').on('afterChange.esPdpHoverSwap', function(){
              if(w.ES_PDP_HoverSwap && typeof w.ES_PDP_HoverSwap.update === 'function') {
                w.ES_PDP_HoverSwap.update();
              }
            });
            w.__esPdpHoverSwapGalleryBound = true;
            return;
          }
          if(tries < 18) setTimeout(waitForGallery, 140);
        })();
      }

      function buildVariantIndex(){
        if(w.ES_PDP__variantsById) return w.ES_PDP__variantsById;
        var map = {};
        try { (w.ES_PDP_VARIANTS || []).forEach(function(v){ map[v.id] = v; }); } catch(e) {}
        w.ES_PDP__variantsById = map;
        return map;
      }

      function getCurrentVariant(){
        try{
          var $sel = $pdpForm.find('#productSelect');
          if(!$sel.length) return null;
          var id = parseInt($sel.val(), 10);
          if(!id) return null;
          return buildVariantIndex()[id] || null;
        } catch(e){ return null; }
      }

      function getSelectedColor(variant){
        if(!variant) return null;
        var idx = (w.ES_PDP_COLOR_OPTION_INDEX != null) ? w.ES_PDP_COLOR_OPTION_INDEX : 0;
        if(idx < 0) return null;
        if(variant.options && variant.options.length) return variant.options[idx] || null;
        if(idx === 0) return variant.option1 || null;
        if(idx === 1) return variant.option2 || null;
        if(idx === 2) return variant.option3 || null;
        return null;
      }

      function getActiveImageSrc(){
        var $img = $pdpRoot.find('.js_prod_main.slick-initialized .slick-current img').first();
        if(!$img.length) $img = $pdpRoot.find('.js_prod_main img').first();
        if(!$img.length){
          $img = $pdpRoot.find('.main_img .engoj_img_main').first();
          if(!$img.length) $img = $pdpRoot.find('[data-es-pdp-main-image], .engoj_img_main').first();
        }
        return ($img && $img.length) ? ($img.attr('src') || '') : '';
      }

      function getImageObjBySrc(src){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !src) return null;
        var cur = normalize(src);
        for(var i=0;i<images.length;i++){
          var s = normalize(images[i].src);
          if(!s) continue;
          if(cur.indexOf(s) !== -1 || s.indexOf(cur) !== -1) return images[i];
        }
        return null;
      }

      function listByVariantIds(ids){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !ids || !ids.length) return [];
        var set = {};
        for(var i=0;i<ids.length;i++) set[ids[i]] = 1;
        var out = [];
        images.forEach(function(img){
          if(!img || !img.src || !img.variant_ids || !img.variant_ids.length) return;
          for(var j=0;j<img.variant_ids.length;j++){
            if(set[img.variant_ids[j]]) { out.push(img.src); return; }
          }
        });
        return out;
      }

      function listForColor(color){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !color) return [];
        var out = [];
        var lc = String(color).toLowerCase();
        var idx = (w.ES_PDP_COLOR_OPTION_INDEX != null) ? w.ES_PDP_COLOR_OPTION_INDEX : 0;
        var variantsById = buildVariantIndex();
        images.forEach(function(img){
          if(!img || !img.src) return;
          var match = false;
          var alt = (img.alt || '').toLowerCase();
          if(alt && alt.indexOf(lc) !== -1) match = true;
          if(!match && img.variant_ids && img.variant_ids.length){
            for(var i=0;i<img.variant_ids.length;i++){
              var v = variantsById[img.variant_ids[i]];
              if(v && v.options && v.options[idx] === color){ match = true; break; }
            }
          }
          if(match) out.push(img.src);
        });
        return out;
      }

      function chooseNextInList(list, currentSrc){
        if(!list || list.length < 2) return null;
        var cur = normalize(currentSrc);
        var idx = -1;
        for(var i=0;i<list.length;i++){
          var n = normalize(list[i]);
          if(!n || !cur) continue;
          if(cur.indexOf(n) !== -1 || n.indexOf(cur) !== -1){ idx = i; break; }
        }
        if(idx === -1) idx = 0;
        var next = (idx + 1) % list.length;
        if(next === idx) return null;
        return list[next] || null;
      }

      function clearAlt(){
        if(!$overlay || !$overlay.length) return;
        lastAlt = '';
        $wrapEl && $wrapEl.removeClass('es-pdp-hovering');
        $overlay.removeAttr('src');
      }

      function setAlt(url){
        if(!$overlay || !$overlay.length) return;
        if(!url) { clearAlt(); return; }
        if(normalize(url) === normalize(lastAlt)) return;
        lastAlt = url;
        $wrapEl && $wrapEl.removeClass('es-pdp-hovering');
        $overlay.removeAttr('src');
        var pre = new Image();
        pre.onload = function(){
          if(!$overlay || !$overlay.length) return;
          $overlay.attr('src', url);
          if($wrapEl && $wrapEl.length && $wrapEl.is(':hover') && shouldEnable()){
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function(){
              if($wrapEl && $wrapEl.is(':hover')) $wrapEl.addClass('es-pdp-hovering');
            }, HOVER_DELAY_MS);
          }
        };
        pre.src = url;
      }

      function chooseAlt(currentSrc, variant){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !currentSrc) return null;
        var curObj = getImageObjBySrc(currentSrc);
        if(curObj && curObj.variant_ids && curObj.variant_ids.length){
          var listByIds = listByVariantIds(curObj.variant_ids);
          var alt1 = chooseNextInList(listByIds, currentSrc);
          if(alt1) return alt1;
        }
        var color = getSelectedColor(variant);
        if(color){
          var listColor = listForColor(color);
          var alt2 = chooseNextInList(listColor, currentSrc);
          if(alt2) return alt2;
        }
        var all = images.map(function(i){ return i.src; });
        return chooseNextInList(all, currentSrc);
      }

      function update(variant){
        ensureOverlay();
        if(!$overlay || !$overlay.length) return;
        variant = variant || getCurrentVariant();
        var currentSrc = getActiveImageSrc();
        if(!currentSrc){ clearAlt(); return; }
        var alt = chooseAlt(currentSrc, variant);
        if(alt && normalize(alt) !== normalize(currentSrc)) setAlt(alt);
        else clearAlt();
      }

      return { update: update };
    })();

    function setVariantStatus(variant, buttonText){
      var status = $pdpForm.find('[data-es-pdp-variant-status]').get(0);
      if (!status) return;
      var title = variant && variant.title && !/Default Title/i.test(String(variant.title)) ? String(variant.title) + ': ' : '';
      status.textContent = title + String(buttonText || '');
    }

    function syncVariantRadios(form, variant){
      if (!variant || !form || !form.length) return;
      for (var i = 0; i < variant.options.length; i++) {
        var wanted = String(variant.options[i]);
        form.find('.swatch[data-option-index="' + i + '"] :radio').each(function(){
          this.checked = String($(this).val()) === wanted;
        });
      }
    }

    function updateVariantImage(variant){
      if (!(variant && variant.featured_image)) return;
      var $main = $pdpRoot.find('[data-es-pdp-main-image], .engoj_img_main').first();
      var element = $main.get(0);
      if (!element) return;
      var source = variant.featured_image.src || variant.featured_image;
      var displaySrc = resizeShopifyImageUrl(source, 1600);
      var mediaId = variant.featured_image.id || '';
      var mediaAlt = variant.featured_image.alt || productData.title || $main.attr('alt') || '';
      var sameMedia = isSamePdpMainMedia($main, source, mediaId);
      $main.attr('alt', mediaAlt);
      if (mediaId) $main.attr('data-es-media-id', String(mediaId));
      var $mainLink = $pdpRoot.find('[data-es-pdp-main-link]').first();
      if (mediaId) $mainLink.attr('data-es-media-id', String(mediaId));
      $pdpForm.find('[data-es-tryon-open]').attr('data-es-tryon-frame', resizeShopifyImageUrl(source, 1200));

      // OptionSelectors calls selectCallback once during PDP boot. Liquid already
      // rendered the selected variant's media with responsive srcset/priority hints.
      // Replacing that same asset with a 1600px URL caused an unnecessary second
      // decode, opacity fade and sticky-gallery remeasure on every PDP entrance.
      if (sameMedia) {
        syncPdpMainLink(source);
        return;
      }

      if (w.Shopify && w.Shopify.Image && typeof w.Shopify.Image.switchImage === 'function') {
        try {
          w.Shopify.Image.switchImage(variant.featured_image, element, function(newImageSizedSrc, ignored, imageElement){
            swapPdpMainImageWhenReady($(imageElement || element), resizeShopifyImageUrl(newImageSizedSrc || source, 1600));
          });
          return;
        } catch(e) {}
      }
      swapPdpMainImageWhenReady($main, displaySrc);
    }

    w.selectCallback = function(variant, selector) {
      var form = (selector && selector.domIdPrefix) ? $('#' + selector.domIdPrefix).closest('form') : $pdpForm;
      if (!form.length) form = $pdpForm;
      var $priceRoot = form.closest('.detail-info');
      var $cta = form.find('[data-es-primary-cta], .engoj-btn-addtocart').first();
      var addText = $cta.attr('data-es-add-to-cart') || $.trim($cta.text()) || $cta.val() || 'Add to Cart';
      var outText = $cta.attr('data-es-out-of-stock') || 'Out of stock';
      var unavailableText = $cta.attr('data-es-unavailable') || outText;

      try {
        w.ES_PDP_SELECTED_VARIANT = variant || null;
        w.ES_PDP_SELECTED_VARIANT_ID = variant && variant.id ? String(variant.id) : '';
        var lbWindow = d.querySelector('[data-es-lb-root] .es-lb__window');
        if (lbWindow) {
          if (variant && variant.id) lbWindow.setAttribute('data-selected-variant-id', String(variant.id));
          else lbWindow.removeAttribute('data-selected-variant-id');
          lbWindow.setAttribute('data-selected-variant-title', String((variant && variant.title) || ''));
          lbWindow.setAttribute('data-selected-variant-price', String(Number((variant && variant.price) || 0) || 0));
        }
        d.dispatchEvent(new CustomEvent('es:pdp:variant', { detail: { variant: variant || null } }));
      } catch(e) {}

      syncVariantRadios(form, variant);

      if (variant && variant.available) {
        $cta.removeClass('disabled es-pdp-oos-visual').prop('disabled', false).removeAttr('aria-disabled').val(addText).text(addText).stop(true, true).css('opacity', '1');
        applyPdpSoldOutCtaVisual($cta, false);
        setVariantStatus(variant, addText);
      } else {
        var stateText = variant ? outText : unavailableText;
        $cta.val(stateText).text(stateText).addClass('disabled es-pdp-oos-visual').prop('disabled', true).attr('aria-disabled', 'true').stop(true, true).css('opacity', '1');
        applyPdpSoldOutCtaVisual($cta, true);
        setVariantStatus(variant, stateText);
      }

      if (variant) {
        $priceRoot.find('.enj-product-price').html(Shopify.formatMoney(variant.price, w.money_format));
        if (variant.compare_at_price > variant.price) {
          $priceRoot.find('.enj-product-price-compare').removeAttr('hidden').html(Shopify.formatMoney(variant.compare_at_price, w.money_format)).show();
        } else {
          $priceRoot.find('.enj-product-price-compare').attr('hidden', 'hidden').html('').hide();
        }
      }

      updateVariantImage(variant);

      if (w.ES_PDP_HoverSwap && typeof w.ES_PDP_HoverSwap.update === 'function') {
        w.setTimeout(function(){ w.ES_PDP_HoverSwap.update(variant); }, 140);
      }
      if (w.__ES_PDP_STICKY_SYNC && typeof w.__ES_PDP_STICKY_SYNC.refresh === 'function') {
        w.__ES_PDP_STICKY_SYNC.refresh();
      }
    };

    var optionSelectorAttempts = 0;
    function initOptionSelectors(){
      if (w.__ES_PDP_OPTION_SELECTORS_INIT__) return;
      if (!(w.Shopify && typeof w.Shopify.OptionSelectors === 'function')) {
        optionSelectorAttempts += 1;
        if (optionSelectorAttempts <= 75) w.setTimeout(initOptionSelectors, 80);
        else $pdpForm.attr('data-es-option-selectors-error', '1');
        return;
      }
      w.__ES_PDP_OPTION_SELECTORS_INIT__ = true;
      new w.Shopify.OptionSelectors('productSelect', {
        product: productData,
        onVariantSelected: w.selectCallback,
        enableHistoryState: true
      });

      if (w.ES_PDP_HoverSwap && typeof w.ES_PDP_HoverSwap.update === 'function') {
        w.setTimeout(function(){ w.ES_PDP_HoverSwap.update(); }, 650);
      }

      var $wrappers = $pdpForm.find('.selector-wrapper');
      if (productData.options && productData.options.length === 1 && productData.options[0] !== 'Title') {
        var $first = $wrappers.eq(0);
        if (!$first.children('label').length) $first.prepend('<label for="productSelect-option-0">' + $('<div>').text(String(productData.options[0])).html() + '</label>');
      }
      if (productData.variants && productData.variants.length === 1 && /Default/.test(String(productData.variants[0].title || ''))) {
        $wrappers.hide();
      }
    }

    function initPdpTextOptionBridge(){
      if (w.__ES_PDP_TEXT_OPTION_BRIDGE__) return;
      w.__ES_PDP_TEXT_OPTION_BRIDGE__ = true;

      function getOptionIndex(input){
        var swatch = input && input.closest ? input.closest('.swatch[data-option-index]') : null;
        if (!swatch) return -1;
        var idx = parseInt(swatch.getAttribute('data-option-index'), 10);
        return isNaN(idx) ? -1 : idx;
      }

      function getForm(input){
        return input && input.closest ? input.closest('form') : null;
      }

      function syncSelectorFromInput(input){
        try {
          if (!input || input.disabled || input.getAttribute('aria-disabled') === 'true') return;
          var idx = getOptionIndex(input);
          if (idx < 0) return;
          var form = getForm(input);
          if (!form) return;
          var selector = $(form).find('.single-option-selector').eq(idx);
          if (!selector.length) return;
          var value = $(input).val();
          if (selector.val() !== value) {
            selector.val(value).trigger('change');
          } else {
            selector.trigger('change');
          }
        } catch(e) {}
      }

      function setRadioChecked(input){
        try {
          if (!input || input.disabled || input.getAttribute('aria-disabled') === 'true') return;
          var name = input.getAttribute('name');
          var form = getForm(input) || d;
          if (name && form.querySelectorAll) {
            form.querySelectorAll('input[type="radio"][name="' + name.replace(/\"/g, '\\\"') + '"]').forEach(function(r){
              r.checked = (r === input);
            });
          } else {
            input.checked = true;
          }
          if (typeof Event === 'function') {
            input.dispatchEvent(new Event('change', { bubbles:true }));
          } else {
            var evt = d.createEvent('Event');
            evt.initEvent('change', true, true);
            input.dispatchEvent(evt);
          }
        } catch(e) {
          try { $(input).prop('checked', true).trigger('change'); } catch(_e) {}
        }
      }

      function syncTextRadiosFromSelectors(){
        try {
          $('#AddToCartForm .swatch.es-swatch--text[data-option-index]').each(function(){
            var swatch = this;
            var idx = parseInt(swatch.getAttribute('data-option-index'), 10);
            if (isNaN(idx)) return;
            var form = swatch.closest ? swatch.closest('form') : null;
            var selector = form ? $(form).find('.single-option-selector').eq(idx) : $();
            if (!selector.length) return;
            var value = selector.val();
            $(swatch).find('input[type="radio"]').each(function(){
              this.checked = ($(this).val() === value);
            });
          });
        } catch(e) {}
      }

      $(d)
        .off('click.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text .es-text-option')
        .on('click.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text .es-text-option', function(e){
          try {
            var input = this.querySelector ? this.querySelector('input[type="radio"]') : null;
            if (!input) return;
            if (!input.checked || e.target !== input) {
              setRadioChecked(input);
            } else {
              syncSelectorFromInput(input);
            }
          } catch(_e) {}
        })
        .off('change.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text input[type="radio"]')
        .on('change.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text input[type="radio"]', function(){
          if (this.checked) syncSelectorFromInput(this);
        })
        .off('change.esPdpTextSelectorSync', '#AddToCartForm .single-option-selector')
        .on('change.esPdpTextSelectorSync', '#AddToCartForm .single-option-selector', function(){
          w.setTimeout(syncTextRadiosFromSelectors, 0);
        });

      w.setTimeout(syncTextRadiosFromSelectors, 80);
      w.setTimeout(syncTextRadiosFromSelectors, 350);
      w.setTimeout(syncTextRadiosFromSelectors, 900);
    }

    initOptionSelectors();
    initLinkedOptions();
    initPdpTextOptionBridge();
    applyPdpSoldOutCtaVisual();
    w.setTimeout(applyPdpSoldOutCtaVisual, 80);
    w.setTimeout(applyPdpSoldOutCtaVisual, 350);
    w.setTimeout(applyPdpSoldOutCtaVisual, 1000);
  });
})(window, document);
